import { css } from 'lit';

const IxFileUploaderStyles = css`
  .ix-file-uploader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 320px;
  }
  .ix-file-uploader--hide-body {
    display: none;
  }
  .dropzone {
    background: var(--clr-surface, #f5f7ff);
    border: 1px dashed var(--clr-info, #2196f3);
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
  }
  .ix-file-uploader__label {
    color: var(
      --ix-file-uploader-label-color,
      var(--clr-on-surface, 'inherit')
    );
    font-family: var(
      --ix-file-uploader-label-font-family,
      var(--root-secondary-font, 'inherit')
    );
    font-size: var(
      --ix-file-uploader-label-font-size,
      var(--text-small-size, 0.75rem)
    );
    font-style: normal;
    font-weight: var(--ix-file-uploader-label-font-weight, 700);
    line-height: var(
      --ix-file-uploader-label-line-height,
      var(--text-small-line-height, 16px)
    );
    letter-spacing: var(
      --ix-file-uploader-label-letter-spacing,
      var(--text-small-letter-spacing, 1.25px)
    );
    text-align: center;
    text-transform: var(--ix-file-uploader-label-text-transform, uppercase);
    margin: auto;
    width: var(--ix-file-uploader-label-width, 100%);
  }
  .ix-file-uploader__help-text {
    color: var(--ix-file-uploader-help-color, var(--clr-on-surface, 'inherit'));
    font-family: var(
      --ix-file-uploader-help-font-family,
      var(--root-secondary-font, 'inherit')
    );
    font-size: var(
      --ix-file-uploader-help-font-size,
      var(--text-small-size, 0.75rem)
    );
    line-height: var(
      --ix-file-uploader-help-line-height,
      var(--text-small-line-height, 16px)
    );
    letter-spacing: var(
      --ix-file-uploader-help-letter-spacing,
      var(--text-small-letter-spacing, 1.25px)
    );
    text-align: center;
  }
  .uploaded-file-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .uploaded-file-list--spaced {
    margin-top: 32px;
  }
  .file-input {
    /*
      Per MDN -> https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
      "Note: opacity is used to hide the file input instead of visibility: hidden or display: none, because assistive technology interprets the latter two styles to mean the file input isn't interactive."
    */
    opacity: 0;

    /*
      Adapted styles from https://tailwindcss.com/docs/screen-readers
    */
    border-width: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    white-space: nowrap;
    width: 1px;
  }
  .error .dropzone {
    border-color: var(--md-sys-color-error);
  }
    
  .error .error-text {
    color: var(--md-sys-color-error);
    padding-left: 0.75rem;
    font-size: 0.75rem;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    line-height: 0.75rem;
  }

  .ix-file-uploader__hint-text{
    font-family: var(--root-primary-font, 'inherit')
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    padding-top: 0.5rem;
    color: var(--clr-on-surface, 'inherit');
  }

  .ix-file-uploader__template-file {
    display: flex;
    align-items: center;
  }
  .delete-file-confirmation-dialog {
    max-width: 560px;
    font-family: var(--root-secondary-font, 'Red Hat Display');
    font-weight: 700;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0.15px;
}
`;

export default IxFileUploaderStyles;
